/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ used: NonNullable<unknown>, total: NonNullable<unknown> }} Storage_Bar_Of_TotalInputs */



/**
* | output |
* | --- |
* | "{used} of {total}" |
*
* @param {Storage_Bar_Of_TotalInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const storage_bar_of_total = /** @type {((inputs: Storage_Bar_Of_TotalInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Storage_Bar_Of_TotalInputs, { locale?: "en" | "de" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ (`${i?.used} von ${i?.total}`)
	return /** @type {LocalizedString} */ (`${i?.used} of ${i?.total}`)
});